import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { AuthContext } from '../../Context/AuthContext';
import DashboardEmployee from './DashboardEmployee';
import Dashboard from './Dashboard';
import CompetencyReportsDashboard from '../competencyReports/CompetencyReportsDashboard';


const DashboardMain = () => {
    const { isEmployee} = useContext(AuthContext);

  return (
    <Box >
    {isEmployee ? <DashboardEmployee /> : <CompetencyReportsDashboard />}

    </Box>
  );
};

export default DashboardMain;